<div class="component-card m-0">
    <div style="display: inline-block;width: 100%;">
        <h1 class="component-title">{{'App Users'|translate}} </h1>
        <i class="pi pi-ellipsis-v spam-menu"></i>
    </div>
    <div class="panel_wrapper">
        <div class="d-flex flex-row justify-content-between pb-4">
            <div class="p-inputgroup div_search_field w-75">
                <button type="button" class="search_btn_icon" (click)="searhSubscibers(searchAppUserModel)"><i
                        class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" [(ngModel)]="searchAppUserModel.name"
                    placeholder="Search...">
                <button type="button" class="search_btn_icon" (click)="clearSearch()"><i
                        class="pi pi-times"></i></button>
            </div>
            <p-dropdown class="src_dropdown" [options]="src_drop_opt" [(ngModel)]="selected_drop_opt" optionLabel="name"
                optionValue="id"></p-dropdown>
            <div class="p-inputgroup div_search_field  w-50">
                <button type="button" class="search_btn_icon" (click)="searhSubscibers(searchAppUserModel)"><i
                        class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" [(ngModel)]="searchAppUserModel.city"
                    placeholder="Location...">
                <button type="button" class="search_btn_icon" (click)="clearSearch()"><i
                        class="pi pi-times"></i></button>
            </div>
        </div>
    </div>
</div>

<p-tabView id="userTabs" class="payment-tabs" (onChange)="changeTabView($event)">
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">{{'All'|translate}} <span class="color_mono_txt"> ( {{totalRecords}} )
                </span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="appUserTemplate"></ng-container>
        </div>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">{{'ACTIVE'|translate}} <span class="color_mono_txt">( {{activeSubscribers}}
                    )
                </span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="appUserTemplate"></ng-container>
        </div>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">{{'SUSPENDED'|translate}} <span class="color_mono_txt"> (
                    {{suspendedSubscribers}}
                    )
                </span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="appUserTemplate"></ng-container>
        </div>
    </p-tabPanel>
</p-tabView>


<ng-template #appUserTemplate>
    <p-progressSpinner *ngIf="spinner" id="full_spinner"></p-progressSpinner>
    <div style="padding-right: 4px; height: 430px;overflow-y: auto;overflow-x: hidden; " infiniteScroll
        [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000" (scrolled)="loadMoreAppUser()"
        [scrollWindow]="false">
        <div *ngFor="let user of appUserList" class="component-card">
            <div class="component-list-card">
                <div class="d-flex flex-row justify-content-between">
                    <div class="d-flex flex-row me-3" style="align-items: self-end;">
                        <img class="admin_picture_list"
                            [src]="user.profilePictureUrl ?  user.profilePictureUrl :imagePath " alt="profile-picture">
                        <div class="admin_info ">

                            <h5 class="title"> <i *ngIf="!user.active"
                                    class="pi pi-user-minus user_susp"></i><span>{{user.firstName}}
                                </span><span>{{user.lastName}}</span></h5>
                            <div class="admin_role">
                                <span>{{user.email}} </span>
                            </div>
                        </div>
                    </div>
                    <div class="div_group_list">
                        <div class="div_lbl_group">
                            <label class="lbl_color_list">{{ 'Location' | translate }}</label>
                            <label class="lbl_list">{{ user.city }}</label>
                        </div>
                        <div class="div_lbl_group">
                            <label class="lbl_color_list">{{ 'PHONE' | translate }}</label>
                            <label class="lbl_list">{{ user.phone }}</label>
                        </div>
                    </div>
                    <div class="ms-2" style="max-width: 140px;">
                        <button class="btn_without_color btn_border_color w-100 mb-2"
                            (click)="detailsAppUser(user.subscriberId)">{{'Details' | translate}}</button>
                        <button *ngIf="user.active" class="btn_in_color  w-100"
                            (click)="suspendedAppUser(user.subscriberId)">{{ 'Suspended'
                            |translate}}</button>
                        <button *ngIf="!user.active" class="btn_in_color  w-100"
                            (click)="unsuspendedAppUser(user.subscriberId)">{{ 'Unsuspended'
                            |translate}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>